var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComigSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 31.625C10.5 27.8538 10.5 25.9681 11.6716 24.7966C12.8431 23.625 14.7288 23.625 18.5 23.625H44.5C48.2712 23.625 50.1569 23.625 51.3284 24.7966C52.5 25.9681 52.5 27.8538 52.5 31.625V47.125C52.5 50.8962 52.5 52.7819 51.3284 53.9534C50.1569 55.125 48.2712 55.125 44.5 55.125H18.5C14.7288 55.125 12.8431 55.125 11.6716 53.9534C10.5 52.7819 10.5 50.8962 10.5 47.125V31.625Z",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 21V18.375C42 17.9108 42 17.6786 41.9923 17.4824C41.7874 12.2679 37.6071 8.08759 32.3926 7.88271C32.1964 7.875 31.9642 7.875 31.5 7.875V7.875C31.0358 7.875 30.8036 7.875 30.6074 7.88271C25.3929 8.08759 21.2126 12.2679 21.0077 17.4824C21 17.6786 21 17.9108 21 18.375V21",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 39.375,
    r: 5.25,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComigSoon);
export default __webpack_public_path__ + "static/media/comigSoon.dd480a261db75dba33b8607218ce56a0.svg";
export { ForwardRef as ReactComponent };